import * as React from 'react'
import type { PasswordStrength } from 'types/business'
import { getPasswordStrengthMinimumCharsInWords } from '@disco/utils/password'
import PasswordRequirementsList from 'components/password/password-requirements-list'

const WeakPasswordError = ({
  passwordStrength,
}: {
  passwordStrength: PasswordStrength
}): React.ReactElement<'div'> => {
  if (passwordStrength === 'standard') {
    return (
      <div>
        {`Sorry! The password you entered doesn’t meet our minimum security requirements. Please ensure it’s at least ${getPasswordStrengthMinimumCharsInWords(
          passwordStrength,
        )} characters, and contains at least one number. We recommend including both uppercase and lowercase characters, special characters and numbers.`}
      </div>
    )
  }

  return (
    <div>
      <p>
        Sorry! The password you entered doesn’t meet our minimum security
        requirements. Please ensure it’s at least{' '}
        {getPasswordStrengthMinimumCharsInWords(passwordStrength)} characters,
        and contains at least one of each of the following:
      </p>
      <PasswordRequirementsList
        omitMinimumChars
        passwordStrength={passwordStrength}
      />
    </div>
  )
}

export default WeakPasswordError
